// @flow

import React from 'react';
import ReactDOM, { hydrate, render } from 'react-dom';
import App from "./App";
import {getDocument, getWindow} from "../Helpers/browsers";

getWindow().then(window => {
  getDocument().then(document => {
    let root = document.getElementById('waystowatch');

    if (root) {
      render(
        <App />,
        root
      );
    }
  });
}); 